export const getShopifyProductById = (id, products) => {
    return products.find((product) => product.node.variants.edges.find((item) => item.node.id === "gid://shopify/ProductVariant/" + id));
};
export const getVariantProductById = (id, products) => {
    const product = getShopifyProductById(id, products);
    const neededProduct = product.node.variants.edges.find((item) => item.node.id === "gid://shopify/ProductVariant/" + id);
    return {
        ...neededProduct,
        internal_sku: neededProduct.node.sku.value,
        productType: product.node.productType,
        title: product.node.title,
        id: product.node.id,
    };
};
export const extractIdFromGid = (gid) => {
    return parseInt(gid.split("/").pop());
};
export function getMetafieldsFromShopifyProduct(data) {
    const transformedArray = [];
    data.forEach((product) => {
        const { productType } = product.node;
        product.node.variants.edges.forEach((variant) => {
            const variantId = variant.node.id;
            const productId = product.node.id;
            transformedArray.push({
                id: variantId,
                productId: productId,
                sku: variant.node.sku ? variant.node.sku.value : "",
                productType: productType?.value,
                options: variant.node.options,
                image: variant.node.image,
                description: product.node.description,
                title: product.node.title,
                price: variant.node.priceV2?.amount,
                compareAtPrice: variant.node.compareAtPriceV2?.amount,
                isNm: product.node.isNm?.value,
            });
        });
    });
    return transformedArray;
}
